import { render, staticRenderFns } from "./ListCongress.vue?vue&type=template&id=4bc90637&"
import script from "./ListCongress.vue?vue&type=script&lang=js&"
export * from "./ListCongress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports